<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="card shadow">
                <div class="table-responsive">
                    <base-table 
                        class="table align-items-center table-flush"
                        thead-classes="thead-light"
                        tbody-classes="list"
                        :data="cpdRecords"
                    >
                        <template slot="columns">
                            <th width="2%">S/N</th>
                            <th width="20%">Certificate ID</th>
                            <th width="30%">Course Title</th>
                            <th width="20%">CPD Points</th>
                            <th width="20%">Completion Date</th>
                            <th width="8%">&nbsp;</th>
                        </template>

                        <template 
                            slot-scope="{row, index}"
                        >
                        <td class="budget">
                            {{ pagination.from+index}}
                        </td>
                        <td class="text-capitalize">
                            {{ row.certificate_id ? row.certificate_id : 'N/A' }}
                        </td>
                        <td>
                            <span v-html="breakword(row.name)"></span>
                        </td>
                        <td>
                            {{ row.point ? row.point : 'N/A' }}
                        </td>
                        <td>
                            {{ row.date | getDateFormat }}
                        </td>
                        <td>
                            <a
                                :href="row.file_url"
                                class="btn btn-sm btn-success"
                                target="_blank"
                                v-if="row.file_url"
                            >
                                <i class="fa fa-download"></i> Download Certifcate
                            </a>
                        </td>

                        </template>

                    </base-table>
                </div>

                <div
                    class="card-footer d-flex justify-content-end bg-transparent"
                    v-if="hasPagination"
                    @click="paginate"
                >
                    <base-pagination
                        :total="pagination.total"
                        align="center"
                        v-model="pagination.number"
                        :perPage="pagination.perPage"

                    >
                    </base-pagination>
                </div>

            </div>
        </div>
        <div class="col-lg-12">
            <hr>
            <h4 class="text-uppercase">
                Total Points for License Year 
                <strong class="text-danger">{{ year }}</strong> 
                <strong class="float-right"><b class="text-danger">{{total}}</b> Points</strong>
            </h4>            
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'CpdPointsData',
        props: ["cpdRecords", "pagination", "hasPagination", "paginate", "year", "total"],
        filters: {
            getDateFormat(value) {
                return moment(value).format('Do MMM, YYYY');
            }
        },
        computed: {
            ...mapGetters(['lock', 'cpdPointUrl'])
        },
        methods: {
            replaceString(value) {
                return value.replace("-", " ");    
            },
            breakword(text, length = 4) {
                if(text) {
                    let splitted = text.split(' ');
                    let halfPoint = Math.ceil(splitted.length / 2);
                    let word = '';
                    for (let index = 0; index < splitted.length; index++) {
                        if((index == halfPoint) && (index >= length)) {
                            word += '<br> ' + splitted[index];
                        } else {
                            word += ' ' + splitted[index];
                        }
                    }
                    return word;
                } else {
                    return 'N/A';
                }
            }
        }
    }
</script>